<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :tabs="tabs">
      <v-row>
        <v-col col="4">
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Icon with Badge</v-card-title>
            <div class="pa-3">
              <v-row justify="space-evenly" class="pa-8">
                <hx-badge id="badge-with-icon-and-counter-1" :counter="1">
                  <v-icon icon="mdi-bell" color="#1b838b"></v-icon>
                </hx-badge>

                <hx-badge id="badge-with-icon-and-counter-99" :counter="99">
                  <v-icon icon="mdi-bell" color="#1b838b"></v-icon>
                </hx-badge>

                <hx-badge id="badge-with-icon-and-counter-100" :counter="100">
                  <v-icon icon="mdi-bell" color="#1b838b"></v-icon>
                </hx-badge>
              </v-row>
            </div>
          </v-card>
        </v-col>

        <v-col col="4">
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Button with Badge</v-card-title>
            <div class="pa-2">
              <v-row class="pa-8" justify="space-evenly">
                <hx-badge id="badge-with-button-and-counter-1" :counter="1">
                  <hx-button label="Button" variant="primary"></hx-button>
                </hx-badge>

                <hx-badge id="badge-with-button-and-counter-99" :counter="99">
                  <hx-button label="Button" variant="primary"></hx-button>
                </hx-badge>

                <hx-badge id="badge-with-button-and-counter-100" :counter="100">
                  <hx-button label="Button" variant="primary"></hx-button>
                </hx-badge>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </UsageExample>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixBadge',
  components: { UsageExample },
  setup() {
    const code = `
// Icon with Badge
<hx-badge id="badge-with-icon" :counter="1">
  <v-icon icon="mdi-bell" color="#1b838b"></v-icon>
</hx-badge>

// Button with Badge
<hx-badge id="badge-with-button" :counter="1">
  <hx-button label="Button" variant="primary"></hx-button>
</hx-badge>
    `;
    return { code };
  },

  data() {
    return {
      tab: 'Badge Usage',
      tabs: ['Badge Usage']
    };
  }
};
</script>
